export default __webpack_public_path__ + "static/media/12.cfe81548.jpg";